export enum ETipoUsoArma {
    UsoPermitido = 1,
    UsoRestrito = 2,
}
